export var USER_INPUT_FILTER_COMPONENT_TYPE;
(function (USER_INPUT_FILTER_COMPONENT_TYPE) {
    USER_INPUT_FILTER_COMPONENT_TYPE["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    USER_INPUT_FILTER_COMPONENT_TYPE["MULTI_CHOICE"] = "MULTI_CHOICE";
    USER_INPUT_FILTER_COMPONENT_TYPE["CHECKBOX"] = "CHECKBOX";
    USER_INPUT_FILTER_COMPONENT_TYPE["RANGE_SLIDER"] = "RANGE_SLIDER";
})(USER_INPUT_FILTER_COMPONENT_TYPE || (USER_INPUT_FILTER_COMPONENT_TYPE = {}));
//# sourceMappingURL=userInputFilterComponentTypes.js.map